import { graphql } from "../../generated"

export const GET_CONTROL_SETTINGS_HISTORY = graphql(`
    query GetControlSettingsHistory(
        $wellControlInput: WellControlSettingsByWellID!
        $historyCount: Int!
        $wellInput: GetWellInput
    ) {
        controlHistory: wellControlSettings(
            last: $historyCount
            input: $wellControlInput
        ) {
            nodes {
                ...ControlSettingFields
            }
        }
        well(input: $wellInput) {
            ...WellIdentificationFields
            configRevision {
                ...WellConfigurationRevisionParameters
            }
        }
    }
`)

export const GET_CONTROL_SETTINGS_FOR_INTERVAL_BY_WELL_ID = graphql(`
    query GetControlSettingsForIntervalByWellID(
        $wellID: ID!
        $interval: TimeIntervalInput!
    ) {
        wellControlSettingsByInterval(wellID: $wellID, interval: $interval) {
            settings {
                ...ControlSettingFields
            }
        }
    }
`)
